module.exports = __webpack_public_path__ + "static/img/login_form_bg.8cafc7a8.png";